import React, { useEffect } from "react";
import { Button, Form, Input, Switch } from "antd";
import { FeatureFlagSettingInterface } from "src/store/callrecorder/featureFlagSettingsSlice";

interface propsInterface {
  params?: FeatureFlagSettingInterface | undefined;
  onFinish: (values: any) => void;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item label="Name">
        <Input value={params?.name} disabled />
        <small style={{ color: '#999' }}>
          Name is a code identifier — defined in FeatureFlag::DEFAULTS and cannot be changed here.
        </small>
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={3} placeholder='What does this flag control?' />
      </Form.Item>

      <Form.Item label="Default enabled" name='default_enabled' valuePropName='checked'>
        <Switch checkedChildren='on' unCheckedChildren='off' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
